import { PortfolioRepo as portfolioRepo } from '../../portfolio/portfolio.repo';
import * as _ from 'lodash';

class PorfolioAdminTradesController implements angular.IOnInit {

  public clientId : number;
  public selectedPortfolioIds : Array<number>;

  public currencies:Array<string>;

  /** @ngInject */
  constructor(private portfolioRepo: portfolioRepo, private iso4217: any) {

  }

  $onInit() {
    this.loadCurrencies();
  }

  $onChanges(changes) {
    if (changes.selectedPortfolioIds)
      {
        this.loadCurrencies();
      }
  }

  loadCurrencies() {
    this.portfolioRepo.getTradeCurrencies(this.selectedPortfolioIds)
    .then((results) => {
      this.currencies = results.data as Array<string>;
    });
  }

  getData = (currency) => {
    return this.portfolioRepo.getTrades(this.selectedPortfolioIds, currency);
  }

  formatCurrency(currency) {
    if (currency)
      return this.iso4217.getCurrencyByCode(currency).symbol;
    return null;
  }

}


export const portfolioTrades: angular.IComponentOptions = {
  template: require('./portfolioadmin.trades.html'),
  controller: PorfolioAdminTradesController,
  bindings: {
    clientId : "<",
    selectedPortfolioIds : "<"
  }
}



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/trades/portfolioadmin.trades.ts